import { render, staticRenderFns } from "./objLineSelected.vue?vue&type=template&id=513b6f20&"
import script from "./objLineSelected.vue?vue&type=script&lang=ts&"
export * from "./objLineSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports